

































import { Component, Vue, Watch } from 'vue-property-decorator';

@Component
export default class Spinner extends Vue {
  private loading: boolean = true;
  private loaded: boolean = false;

  @Watch('$route')
  private onRouteChange(to: any, from: any): void {
    if (to.name === 'swiper') {
      setTimeout(() => {
        this.loading = false;
      }, 2000);
      this.loaded = true;
    }
  }
}
